import {canCategorizeCurrentCartAssets} from './canCategorizeCurrentCartAssets';

export const canCategorizeRemoveCurrentCartAssets = (): boolean => canCategorizeCurrentCartAssets();
